import useSWR from "swr";
import {
  InvoiceSummaryResponse,
  InvoiceDetailsModel,
  InvoiceTotalInfoModel,
  SearchResponseTypeModel,
} from "@attelas/shared";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { useMemo } from "react";

type SearchParams = {
  id: string;
  type: SearchResponseTypeModel;
};

export const useInvoicesByCustomerOrId = (searchParams: SearchParams | null | undefined) => {
  const { id, type } = searchParams ?? {};
  const fetcher = useSWRFetcher();

  const getApi = () => {
    if (!id) return null;

    return type === "Contact"
      ? `${environment.apiUrl}/api/invoices/customer/${id}/summary?isAuthorizedOnly=false`
      : `${environment.apiUrl}/api/invoices/${id}`;
  };

  const { data, isLoading, error } = useSWR<InvoiceSummaryResponse | InvoiceDetailsModel | InvoiceDetailsModel[]>(
    getApi(),
    (url: string) => fetcher(url),
    {}
  );

  const invoices: InvoiceDetailsModel[] = useMemo(() => {
    if (!data) return [];

    if (type === "Contact") {
      return (data as InvoiceSummaryResponse)?.invoices ?? [];
    }

    return Array.isArray(data) ? data : [data as InvoiceDetailsModel];
  }, [data, type]);

  const totalInfo: InvoiceTotalInfoModel | null = useMemo(() => {
    if (type === "Contact") {
      const summary = data as InvoiceSummaryResponse;
      return {
        totalAmount: summary?.totalAmount ?? 0,
        totalDueAmount: summary?.totalDueAmount ?? 0,
        link: summary?.link ?? "",
      };
    }
    return null;
  }, [data, type]);

  return {
    invoices,
    totalInfo,
    isLoading,
    isError: error,
  };
};
